import React from 'react';
import { Redirect } from 'react-router';
import { ERoutesFranchiseePrivate, RoutesCirPrefix } from 'common/models/routesModel';
import { isCirEnabled } from 'common/config/env.config';

export const RootFranchiseePage: React.FC = () => (
  <Redirect to={isCirEnabled ? `${RoutesCirPrefix}${ERoutesFranchiseePrivate.GeneratePO}` : ERoutesFranchiseePrivate.StoreList} />
);
